import { createAction, props } from '@ngrx/store';
import { ActionResponse } from 'src/app/models/action-response';
import { ReplaceProductServiceDueDatesStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/init-step/due-dates-step';
import { ReplaceProductServiceInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/init-step/init-step';
import { ReplaceProductServiceBillingStep26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-billing-step/replace-product-service-billing-step-v26';
import { ReplaceProductServiceRequestV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-confirm-step/replace-product-service-request-v26';
import { ReplaceProductServiceReplacementStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/replace-product-service-wizard/replace-product-service-replacement-step/replace-product-service-replacement-step-v26';

export const selectInitStep = createAction(
  '[V26 Catalog Page] Select Init Replace Product Service Information Step',
  props<{ initStep: ReplaceProductServiceInitStepV26 }>(),
);

export const selectDueDatesStep = createAction(
  '[V26 Wizard Due Date Step] Select Replace Product Service Due Date Step',
  props<{ dueDatesStep: ReplaceProductServiceDueDatesStepV26 }>(),
);

export const selectReplacementStep = createAction(
  '[V26 Wizard Replacement Step] Select Replace Product Service Replacement Step',
  props<{ replacementStep: ReplaceProductServiceReplacementStepV26 }>(),
);

export const selectBillingStep = createAction(
  '[V26 Wizard Billing Step] Select Replace Product Service Billing Step',
  props<{ billingStep: ReplaceProductServiceBillingStep26 }>(),
);

export const exitReplaceProductServiceWizard = createAction('[V26 ReplaceProductService Wizard Page] Exit Replace Product Service Wizard');

export const destroyWizard = createAction('[V26 ReplaceProductService Wizard Page] Destroy Wizard');

export const createNewReplaceProductService = createAction(
  '[V26 Wizard Confirmation Step] Create Replace Product Service Information Step',
  props<{ request: ReplaceProductServiceRequestV26 }>(),
);

export const createNewReplaceProductServiceSuccess = createAction(
  '[V26 Wizard Confirmation Step] Create Replace Product Service Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewReplaceProductServiceFail = createAction(
  '[V26 Wizard Confirmation Step] Create Replace Product Service Information Step Fail',
  props<{ errorMessage: string }>(),
);
